import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const GiftCard: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--gift-card')}
    width="30px"
    height="20px"
    viewBox="0 0 30 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      id="2.-Check-Out-(Guest)"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="1.10_Payment_giftCard_Applied"
        transform="translate(-672.000000, -496.000000)"
      >
        <g id="Slider" transform="translate(633.000000, 94.000000)">
          <g id="Group" transform="translate(23.000000, 390.000000)">
            <g
              id="icn_genericCreditCard"
              transform="translate(16.000000, 12.000000)"
            >
              <g id="Group-2">
                <rect
                  id="Rectangle"
                  fill="#B8B8B8"
                  x="0"
                  y="0"
                  width="30"
                  height="20"
                  rx="2"
                />
                <rect
                  id="Rectangle-2"
                  fill="#FFFFFF"
                  x="0"
                  y="4.44444444"
                  width="30"
                  height="3.33333333"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default GiftCard;
